import React, { useEffect, useState } from 'react';
import IncrementDecrement from '../../../FlowConfigurationInputs/IncrementDecrement/IncrementDecrement';
// Import Recoil
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { saveAvailable, initialActions, changedFields } from "../../../../recoil-store/recoil-state";

// Import Helpers
import { CheckIfFlowUpdated } from '../../../../helpers/helper';
/**
 * @description This function lets you return component according to the name of the incoming action.
 * @param       action - object
 * @param       variables - object variable list
 * @returns     JSX.Element
 * @author      ibrahim AKIN
 */
function Scroll({ action }) {
    const [pixel, setPixel] = useState();
    const initialActionsData = useRecoilValue(initialActions);
    const setSaveAvailable = useSetRecoilState(saveAvailable);
    const [changedFieldsState, setChangeFields] = useRecoilState(changedFields);

    useEffect(() => {
        if (!action.fields.incrementState) {
            action.fields.incrementState = { value: 1 };
            setPixel(action.fields.incrementState.value * 114);
        }
    }, [action]);

    const handleIncrement = () => {
        action.fields.incrementState.value++;
        setPixel(action.fields.incrementState.value * 114);
        const field = initialActionsData[action.id]?.fields.incrementState;
        const oldValue = !field ? undefined : field.value;
        CheckIfFlowUpdated('incrementState', action, oldValue, action.fields.incrementState.value, setSaveAvailable, setChangeFields, changedFieldsState);
    };

    const handleDecrement = () => {
        if (action.fields.incrementState.value - 1 > 0) {
            action.fields.incrementState.value--;
            setPixel(action.fields.incrementState.value * 114);
            const field = initialActionsData[action.id]?.fields.incrementState;
            const oldValue = !field ? undefined : field.value;
            CheckIfFlowUpdated('incrementState', action, oldValue, action.fields.incrementState.value, setSaveAvailable, setChangeFields, changedFieldsState);
        }
    };

    return <IncrementDecrement action={action} handleIncrement={handleIncrement} handleDecrement={handleDecrement} />;
}

export default Scroll;